const agendaModuleRelationships = {
  layers: [
    { key: 'crm_leads', order: 1, name: 'Leads CRM', icon: 'Users', description: 'Personas en proceso comercial (con teléfono/correo para la IA).', path: '/tenant/crm/leads' },
    { key: 'agenda', order: 2, name: 'Agenda', icon: 'Calendar', description: 'Citas, bloqueos y disponibilidad del equipo.', path: '/tenant/agenda' },
    { key: 'business_hours', order: 3, name: 'Horario del negocio', icon: 'Clock', description: 'Apertura/cierre que la IA respeta al proponer citas.', path: '/tenant/business' },
    { key: 'deals', order: 4, name: 'Oportunidades', icon: 'LayoutGrid', description: 'Pipeline de negociación.', path: '/tenant/crm/pipeline' },
    { key: 'tasks', order: 5, name: 'Tareas', icon: 'ListChecks', description: 'Seguimiento y acciones pendientes.', path: '/tenant/crm/tasks' },
  ],
  summary:
    'Lead en CRM → cita en Agenda (humano o IA) respetando horario y bloqueos → opcionalmente avanza el deal → tareas de seguimiento. ' +
    'Admin ve todas las citas; vendedor solo las suyas. Google Calendar se sincroniza al vendedor con Google conectado.',
  futureLayer: 'Sugerencia automática de 3 huecos libres en voz y sync bidireccional con Google son mejoras posibles.',
};

export default agendaModuleRelationships;
